var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-list-2"},_vm._l((_vm.list),function(ref){
var key = ref.key;
var checked = ref.checked;
var disabled = ref.disabled;
var label = ref.label;
return _c('label',{key:key},[_c('input',{attrs:{"type":"radio","disabled":disabled},domProps:{"checked":checked},on:{"change":function($event){return _vm.change(key)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }